import React from 'react';
import PropTypes from 'prop-types';

const CategoryScroller = ({ categoriesData, onCategorySelect, currentCategory, layout }) => {
  return (
    <div className={`category-scroller-container ${layout === 'vertical' ? 'category-scroller-container-vertical' : ''}`}>
      <div className={`category-scroller ${layout === 'vertical' ? 'category-scroller-vertical' : ''}`}>
        {categoriesData.map((category) => (
          <div
            key={category.id}
            className={`category-item ${layout === 'vertical' ? 'category-item-vertical' : ''}`}
            onClick={() => onCategorySelect(category)}
          >
            <div
              className={`category-image-wrapper ${
                currentCategory === category.title ? 'active-category-image-wrapper' : ''
              }`}
            >
              <img
                src={category.imageUrl}
                alt={category.title}
                className="category-image"
              />
            </div>
            <p className="category-name">{category.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

CategoryScroller.propTypes = {
  categoriesData: PropTypes.array.isRequired,
  onCategorySelect: PropTypes.func.isRequired,
  currentCategory: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
};

CategoryScroller.defaultProps = {
  currentCategory: null,
  layout: 'horizontal',
};

export default CategoryScroller;



